import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    NewsListShow: false,
    NewsListShowDelayed: false,
  },
  mutations: {
    ToggleNewBoardStatus(state, shown) {
      if (shown) {
        state.NewsListShow = shown;
        setTimeout(function () {
          state.NewsListShowDelayed = shown;
        }, 10);
      } else {
        state.NewsListShowDelayed = shown;
        setTimeout(function () {
          state.NewsListShow = shown;
        }, 3000);
      }
    },
  },
});
